import React from 'react';
import './Error404.scss';

const Error404 = () => {
  return ( 
    <h1>Error</h1>
   );
}
 
export default Error404;